import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { locationKind } from "app/location/location-kind.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-location-kind-select",
  templateUrl: "./location-kind-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class LocationKindSelectComponent implements OnInit {
  public readonly locationKindChange = output<string>();
  @Input() public locationKind: string;
  public readonly disabled = input(false);
  public readonly showAll = input(true);

  public subscription = new Subscription();
  public locationKindList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildLocationKindList();
  }

  public onLocationKindChange(event) {
    this.locationKindChange.emit(event.value);
  }

  private buildLocationKindList(): void {
    if (this.showAll()) {
      this.locationKindList.push({ label: "All kinds", value: null });
    }
    Object.keys(locationKind).map((key) => {
      this.locationKindList.push({
        label: locationKind[key],
        value: locationKind[key],
      });
    });
  }
}
